import { render, staticRenderFns } from "./BaggageExplain.vue?vue&type=template&id=30f52d37"
import script from "./BaggageExplain.vue?vue&type=script&lang=js"
export * from "./BaggageExplain.vue?vue&type=script&lang=js"
import style0 from "./BaggageExplain.vue?vue&type=style&index=0&id=30f52d37&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports